import { GOVERNMENT_PREFIX } from "@/lib/portal-nav";
import { SESSION_KEYS } from "@/types/session-storage";
import { useDashboardState } from "./use-dashboard-state";
import { usePortalSection } from "./use-portal-section";

export function useGovernmentUserDashboardState() {
  const activeSection = usePortalSection(GOVERNMENT_PREFIX);
  return useDashboardState({
    activeSection,
    selectedLicenseTypesKey:
      SESSION_KEYS.GOVERNMENT_DASHBOARD_SELECTED_LICENSE_TYPES,
    selectedRegionsKey: SESSION_KEYS.GOVERNMENT_SELECTED_REGIONS,
    isMapViewKey: SESSION_KEYS.GOVERNMENT_DASHBOARD_IS_MAP_VIEW,
    columnFiltersKey:
      SESSION_KEYS.GOVERNMENT_DASHBOARD_REGISTRATIONS_COLUMN_FILTERS,
    inactiveRegistrationsColumnFiltersKey:
      SESSION_KEYS.GOVERNMENT_DASHBOARD_INACTIVE_REGISTRATIONS_COLUMN_FILTERS,
    unregisteredPropertiesColumnFiltersKey:
      SESSION_KEYS.GOVERNMENT_DASHBOARD_UNREGISTERED_PROPERTIES_COLUMN_FILTERS,
    inspectionsColumnFiltersKey:
      SESSION_KEYS.GOVERNMENT_DASHBOARD_INSPECTIONS_COLUMN_FILTERS,
    includeJurisdictions: false,
  });
}
